import type { TopUpAction } from "./model"
import type { Uuid } from "@/utils"

/**
 * Constructors for the queued post-payment action. The backend request DTO has
 * no defaults, so these always produce a complete object (explicit null / empty
 * for the fields that don't apply to a given action type).
 */

export const topUpAction = (): TopUpAction => ({
  type: "top_up",
  emails: [],
  locale: null,
  personalMessage: null,
  briefId: null,
})

export const sendAssignmentsAction = (
  emails: string[],
  locale: string,
  personalMessage: string | null,
  briefId: Uuid | null,
): TopUpAction => ({
  type: "send_assignments",
  emails,
  locale,
  personalMessage,
  briefId,
})

export const selfAssignmentAction = (briefId: Uuid | null): TopUpAction => ({
  type: "self_assignment",
  emails: [],
  locale: null,
  personalMessage: null,
  briefId,
})
